import { createFileRoute } from '@tanstack/react-router';
import { UpdateNamePage } from '../components/pages/SettingsPage/UpdateNamePage';

export const Route = createFileRoute('/account/settings_/name')({
  component: UpdateNamePage,
});
